import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Form } from 'components/shared/Form/Form'

import {
  ASSESSMENT_GROUP_FIELD,
  COMMENT_FIELD,
  SCORE_FIELD,
  SKILL_RANGE,
} from '../../model'

import styles from './AssessmentForm.module.scss'

export const AssessmentForm = ({
  className = undefined,
  control,
  index,
  watch,
}) => {
  const score = watch(`${ASSESSMENT_GROUP_FIELD}[${index}].${SCORE_FIELD}`)

  return (
    <Form
      className={cx(styles.assessment, { [className]: Boolean(className) })}
    >
      <span className={styles.scoreTitle}>{t`Overall score`}</span>
      <Box align="center" className={styles.score} justify="center">
        {R.pipe(
          R.add(1),
          R.range(1),
          R.map(value => (
            <Form.Field
              className={styles.field}
              id={`score-${value}`}
              field="score"
              key={value}
              label={value}
              labelSize="medium"
              name={`${ASSESSMENT_GROUP_FIELD}[${index}].${SCORE_FIELD}`}
              score={value}
              isScoreActive={R.equals(Number(score), value)}
              {...{ control }}
            />
          )),
        )(SKILL_RANGE)}
      </Box>
      {/*<Form.Field
        field="textarea"
        fieldClassName={styles.textarea}
        label={t`Notes`}
        name={`${ASSESSMENT_GROUP_FIELD}[${index}].${COMMENT_FIELD}`}
        isOptional
        {...{ control }}
      />*/}
    </Form>
  )
}
